/**
 * [ File :: G_ImageSwitch.js ]
 *
 * @경로 : /public/scripts/game/lcPlugIn/canvas/grid/dev/child/image/G_ImageSwitch.js
 * @목적 : 스위치 이벤트를 가지는 객체
 * @진행 : 종료
 * @주의 : 없음
 * @일자 : 2018.mm.dd
 * @작성 : created by SDM
 * @참조 :
 */

import G_ImageGrid from 'canvas/grid/dev/child/image/G_ImageGrid';

const G_ImageSwitch = (function() {

	return class extends G_ImageGrid {
		constructor(obj) { super(obj); }

		/**
		 * [ Function (public) :: buttonSwitch ]
		 *
		 * @DES :: 스위치 누르기
		 * @IP1 ::
		 * @O.P ::
		 * @S.E ::
		 */
		buttonSwitch() { /*TODO*/ }

		/**
		 * [ Function (public) :: toggleSwitch ]
		 *
		 * @DES :: 스위치 토글하기
		 * @IP1 :: cb {func}
		 * @O.P ::
		 * @S.E ::
		 */
		toggleSwitch(cb) {
			/**
			 * [STEP]
			 *
			 * #01. 타겟이 있는지 확인
			 * #02. 스위치 이미지를 좌우 반전
			 * #03. 타겟 객체를 토글
			 * */

			if(typeof this._target !== 'undefined') {
				// [#] 스위치 동작

				const ANIMATOR = this.CODMOS.ANIMATE;
				const TIME = this.CODMOS.time;

				// [S] 좌우반전
				ANIMATOR.reverseX(this);

				// [S] 타겟토글
				this._target.forEach((v) => {
					const TARGET = this.CODMOS.WORLD[v];
					if(TARGET) {
						console.log(TARGET._visible);
						if(!TARGET._visible) {
							// [#] 안보임 > 보임
							this.CODMOS.ANIMATE._tween.downToCenter(TARGET, TIME, () => {
								TARGET._visible = true; // 보임처리
								TARGET._setActiveAnimate(TARGET._active); // 활성처리
							});
						}
						else {
							// [#] 보임 > 안보임
							this.CODMOS.ANIMATE._tween.centerToDown(TARGET, TIME, () => {
								TARGET._visible = false; // 안보임처리
								TARGET._setActiveAnimate(!TARGET._active); // 비활성처리
							});
						}
					}
				});

				// [#] callback (여러개의 객체가 동시에 동작하기 때문에 콜백을 받기가 어려움)
				setTimeout(function() {
					if(cb) cb();
				}, TIME);

			}
			else { if(cb) cb(); }
		}

	}
}());

export default G_ImageSwitch;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/grid/dev/child/image/G_ImageSwitch.js